import React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseToolbarFeature from '../../../common/feature/base-toolbar-feature';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import PictureTransparencyPresetMenu from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/picture-transparency-preset-menu';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { isImageOrImageFillShape } from '@src/slide/domain/ui-model/elements/element-judge';

@Feature()
export class PictureTransparencyFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    private currentProps;

    public constructor() {
        super();
    }

    public renderMenu() {
        const model = this.getFirstPictureModel();
        if (!model) {
            return null;
        }
        const alpha = this.getCurrentAlpha();
        this.currentProps = { alpha };
        return <PictureTransparencyPresetMenu
            pictureProps={model.props}
            onPresetStyleClick={this.handlePresetStyleClick}
            onPresetStyleMouseEnter={this.handlePresetStyleMouseEnter}
            onPresetStyleMouseLeave={this.handlePresetStyleMouseLeave}
        />;
    }

    private getFirstPictureModel(): IPictureModel {
        const model = this.getSelectionService().getSelectedModel();
        const selectedModels = getAllChildModels(model as IElementBaseModel);
        return selectedModels.find(isImageOrImageFillShape) as IPictureModel;
    }

    private handlePresetStyleMouseEnter = (props) => {
        this.getToolbarMenu()?.callback('', ActionType.INSERT_PICTURE, { image: { alpha: props.alpha } }, { onlyChangeUI: true, onlyPreview: true });
    };

    private handlePresetStyleMouseLeave = () => {
        this.getToolbarMenu()?.callback('', ActionType.INSERT_PICTURE, { image: { alpha: this.currentProps.alpha } }, { onlyChangeUI: true, onlyPreview: true });
    };

    private handlePresetStyleClick = (props) => {
        this.getToolbarMenu()?.callback('', ActionType.INSERT_PICTURE, { image: { alpha: props.alpha } }, { onlyChangeUI: false, onlyPreview: false });
    };

    private getCurrentAlpha() {
        const model = this.getFirstPictureModel();
        return model.props.style.alpha ?? model.props.style.fillBackground?.image?.alpha;
    }
}
